import CompanySecuritySetup from "./CompanySecuritySetup/CompanySecuritySetup.vue";

const routes = [
    {
        path: "/axxess-central/reports/company-security-setup",
        component: CompanySecuritySetup,
        name: "Company Security Setup (CSU)",
        meta: {
            menuName: "Company Security Setup",
            navItem: "tabCompanySecuritySetup",
            showAxxessCentral: true
        }
    }
];
export default routes;
